import { Injectable, NgZone } from '@angular/core';
import { sleep$$, tick$$ } from '../util/util';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { filter, first } from 'rxjs/operators';

/**
 * Helper service to find customers with active contract.  Needed for debugging
 *
 * TODO BFR replace with ngx-page-scroll
 */
@Injectable({ providedIn: 'root' })
export class ScrollService {
  private scrollInProgress = false;
  private stopScroll = new BehaviorSubject<boolean>(false);

  constructor(private ngZone: NgZone) {}

  /**
   *
   * @param target : string name with the target element ID
   * @param offset : number amount of pixels for offset (can be negative)
   * @param duration
   */
  async scrollToElement(target: string | HTMLElement, offset = -10, duration = 600): Promise<void> {
    await tick$$();
    this.ngZone.runOutsideAngular(async () => {
      const element = this.getElement(target);
      if (element?.clientHeight) {
        const fixedHeader = document.getElementById('nav-header');
        const y = this.getElementTop(element) - fixedHeader.offsetHeight + offset;
        // console.log(`y: ${y} / offset: ${offset} / elementTop: ${this.getElementTop(element)} / header-height: ${fixedHeader.offsetHeight} / window.scrollY: ${window.scrollY}`);
        await this.stopScrollInProgress();
        this.scrollInProgress = true;
        try {
          await this.animateScroll(window.scrollY, y, duration, 50);
        } finally {
          this.scrollInProgress = false;
          this.stopScroll.next(false);
        }
      } else if (duration > 100) {
        setTimeout(() => {
          this.scrollToElement(target, offset, duration - 100);
        }, 100);
      }
    });
  }

  private getElement(targetElementId: string | HTMLElement): HTMLElement {
    let element = null;
    if (typeof targetElementId === 'string') {
      element = document.getElementById(targetElementId);
    } else {
      element = targetElementId;
    }
    return element;
  }

  private getElementTop(element: HTMLElement): number {
    return element.getBoundingClientRect().top + window.scrollY;
  }

  private async animateScroll(startScrollY: number, targetScrollY: number, duration: number, interval: number): Promise<void> {
    const scrollYChange = targetScrollY - startScrollY;
    const scrollSteps = [];
    for (let t = 0; t <= duration; t += interval) {
      scrollSteps.push(((-1 * scrollYChange) / 2) * (Math.cos((Math.PI * t) / duration) - 1) + startScrollY);
    }
    await this.doScrollStep(scrollSteps, interval);
  }

  private async doScrollStep(scrollSteps: number[], interval: number): Promise<void> {
    if (this.stopScroll.value) {
      return;
    }
    if (scrollSteps && scrollSteps.length) {
      const scrollY = scrollSteps[0];
      window.scroll(window.scrollX, scrollY);
      if (scrollSteps.length > 1) {
        await sleep$$(interval);
        await this.doScrollStep(
          scrollSteps.filter((s, i) => i > 0),
          interval
        );
      }
    }
  }

  private async stopScrollInProgress(): Promise<void> {
    if (this.scrollInProgress) {
      this.stopScroll.next(true);
      await firstValueFrom(this.stopScroll
        .pipe(
          filter(stop => !stop),
          first()
        ));
    }
  }
}
